import { Box, HStack, MenuItem } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { IconFlag } from "src/components/icons";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { useUserStore } from "src/stores/user-store";
import { useReportModalStore } from "../store/report-modal-store";

interface IFeedReportMenuItemProps {
    onClick?: (entityId: string) => void;
    entityId: string;
}

export const FeedReportMenuItem = ({ entityId }: IFeedReportMenuItemProps) => {
    const { t } = useTranslation("feed");
    const store = useReportModalStore();
    const { isLoggedIn } = useUserStore();
    const { openLoginModal } = useLinkBuilder();

    const onClickReport = () => {
        if (!isLoggedIn) {
            openLoginModal();
            return;
        }

        store.setIsOpen(true);
        store.setEntityId(entityId);
    };

    return (
        <>
            <MenuItem onClick={onClickReport}>
                <HStack>
                    <IconFlag boxSize={3} />
                    <Box>{t("buttons.report")}</Box>
                </HStack>
            </MenuItem>
        </>
    );
};
